// import { useState } from "react";
// import { useGlobalContext } from "../GlobalContext";

// export default function useLogin() {
//   const [loading, setLoading] = useState(false);

//   const { api, setAccessToken, setAdminId, setAdmin } = useGlobalContext();

//   const login = async ({
//   mobile,
//   password,
//   step,
//   otp,
//   latitude,
//   longitude,
// }) => {
//     setLoading(true);

//     try {
//       const payload = {
//   mobile,
//   password,
//   step: step.toString(),
//   otp: step === 2 ? otp : "",
//   latitude: latitude ? latitude.toString() : "0.0",
//   longitude: longitude ? longitude.toString() : "0.0",
// };

// console.log("LOGIN PAYLOAD:", payload);
//       const response = await api.post("/api/Admin/v1.0/login", payload, {
//         skipAccessDenied: true,
//       });

//       if (response.data?.responseCode === "00") {
//         if (step === 1) {
//           return { success: true, nextStep: 2 };
//         }

//        if (step === 2) {
//   const adminData = response.data?.response;

//   sessionStorage.setItem("admin", JSON.stringify(adminData));

//   // ADD THIS

//   setAccessToken(adminData?.accessToken);
//   setAdminId(adminData?.userId);
//   setAdmin(adminData);

//   return { success: true, completed: true };
// }
//       }

//       if (
//         response.data?.responseCode === "02" ||
//         response.data?.responseCode === "03" ||
//         response.data?.responseCode === "98" ||
//         response.data?.responseCode === "401"
//       ) {
//         return {
//           success: false,
//           message: response.data?.responseMessage || "Access denied",
//         };
//       }

//       return {
//         success: false,
//         message: response.data?.responseMessage || "Login failed",
//       };
//     } catch (error) {
//       console.error("login error:", error);

//       return {
//         success: false,
//         message: "Login failed. Please try again.",
//       };
//     } finally {
//       setLoading(false);
//     }
//   };

//   return { login, loading };
// }

import { useState } from "react";
import { useGlobalContext } from "../GlobalContext";

export default function useLogin() {
  const [loading, setLoading] = useState(false);

  const { api, setAccessToken, setAdminId, setAdmin } = useGlobalContext();

  const login = async ({
    mobile,
    password,
    step,
    otp,
    latitude,
    longitude,
  }) => {
    setLoading(true);

    try {
      const currentStep = Number(step);

      const payload = {
        mobile: String(mobile || "").trim(),
        password: String(password || ""),
        step: String(currentStep),
        otp: currentStep === 2 ? String(otp || "") : "",
        latitude: String(latitude || "0.0"),
        longitude: String(longitude || "0.0"),
      };

      const { data } = await api.post("/api/Admin/v1.0/login", payload, {
        skipAccessDenied: true,
      });

      console.log("LOGIN API DATA:", data);

      const responseCode = String(data?.responseCode || "");
      const responseMessage = data?.responseMessage || "Login failed";

      // Invalid credentials सहित सभी failure responses
      if (responseCode !== "00") {
        return {
          success: false,
          message: responseMessage,
          responseCode,
        };
      }

      if (currentStep === 1) {
        return {
          success: true,
          nextStep: 2,
          message: responseMessage,
        };
      }

      if (currentStep === 2) {
        const adminData = data?.response;

        if (!adminData) {
          return {
            success: false,
            message: "Admin details were not received",
          };
        }

        sessionStorage.setItem("admin", JSON.stringify(adminData));

        sessionStorage.setItem("accessToken", adminData?.accessToken || "");

        sessionStorage.setItem("adminId", String(adminData?.userId || ""));

        setAccessToken(adminData?.accessToken || "");
        setAdminId(adminData?.userId || "");
        setAdmin(adminData);

        return {
          success: true,
          completed: true,
          message: responseMessage,
        };
      }

      return {
        success: false,
        message: responseMessage,
      };
    } catch (error) {
      console.error("LOGIN ERROR:", error);
      console.error("LOGIN ERROR DATA:", error?.response?.data);

      return {
        success: false,
        message:
          error?.response?.data?.responseMessage ||
          error?.response?.data?.message ||
          "Login failed. Please try again.",
      };
    } finally {
      setLoading(false);
    }
  };

  return { login, loading };
}